import React, {createRef, useRef} from "react";
import APIManager from "../../services/api-manager";
import {object} from "prop-types";

export default class AddressLookup extends React.Component {
    constructor(props) {
        super(props);

        this.APIManager = new APIManager();
        this.state = {
            lookUpQuery: '',
            address: {},
            foundAddresses: {},
            addressList: false,
            renderAddress: false,
            loadingAddress: false,
            valid: true,

            validateErrors: {},
            geoCode: false,
        }

        this.defaultAddress();

        // this.lookUpSearchRef = React.createRef();
        this.lookUpListRef = React.createRef();
        this.postcodeRef = React.createRef();
        this.streetRef = React.createRef();
        this.buildingNumRef = React.createRef();
        this.buildingNameRef = React.createRef();
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
        document.addEventListener("reactAddressValidate", this.validate);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
        document.removeEventListener("reactAddressValidate", this.validate);
    }

    validate = (e) => {
        let validateErrors = {};

        if(!this.state.address || Object.keys(this.state.address).length === 0) validateErrors.Address = 'Please select an address.'

        this.setState({
            valid: (Object.keys(validateErrors).length < 1),
            validateErrors: validateErrors
        }, () => {
            e.detail.validate(this.state.valid);
        });
    }

    handleClickOutside = (e) => {
        let isOutside = true;
        // console.log(this.lookUpListRef);
        if (this.lookUpListRef && this.lookUpListRef.current.contains(e.target)) isOutside = false;
        if (isOutside) this.setState({addressList: false})
    }

    defaultAddress = () => {
        this.setState({
            address: {
                AdminAreaCode: '',
                AdminAreaName: '',
                Barcode: '',
                Block: '',
                BuildingName: '',
                BuildingNumber: '',
                City: '',
                Company: '',
                CountryIso2: 'GB',
                CountryIso3: 'GBR',
                CountryIsoNumber: '826',
                CountryName: 'United Kingdom',
                DataLevel: '',
                Department: '',
                District: '',
                DomesticId: '',
                Field1: '',
                Field2: '',
                Field3: '',
                Field4: '',
                Field5: '',
                Field6: '',
                Field7: '',
                Field8: '',
                Field9: '',
                Field10: '',
                Field11: '',
                Field12: '',
                Field13: '',
                Field14: '',
                Field15: '',
                Field16: '',
                Field17: '',
                Field18: '',
                Field19: '',
                Field20: '',
                Id: '',
                Label: '',
                Language: '',
                LanguageAlternatives: '',
                Line1: '',
                Line2: '',
                Line3: '',
                Line4: '',
                Line5: '',
                Neighbourhood: '',
                POBoxNumber: '',
                PostalCode: '',
                Province: '',
                ProvinceCode: '',
                ProvinceName: '',
                SecondaryStreet: '',
                SortingNumber1: '',
                SortingNumber2: '',
                Street: '',
                SubBuilding: '',
                Type: '',
            }
        }, this.updateAddressForm);
    }

    //finds address for Postcode
    addressLookupPostcode = (query) => {
        let recursiveAddressSearch = (query) => this.APIManager.findAddressByContainer(query, data => {
            let Addresses = this.state.foundAddresses;

            for (let i = 0; i < data.Items.length; i++) {
                let item = data.Items[i];
                if (item.Type === 'Address') {
                    Addresses[item.Id] = item;
                    this.setState({foundAddresses: Addresses});
                } else {
                    recursiveAddressSearch(item.Id);
                }
            }
        });

        this.setState({foundAddresses: []}, () => this.APIManager.findAddressByPostcode(query, data => {
            let Addresses = this.state.foundAddresses;

            for (let i = 0; i < data.Items.length; i++) {
                let item = data.Items[i];
                if (item.Type === 'Address') {
                    Addresses[item.Id] = item;
                    this.setState({foundAddresses: Addresses});
                } else {
                    recursiveAddressSearch(item.Id);
                }
            }
        }));

        this.setState({addressList: true});
    }

    //Finds addresses for geolocation
    addressLookupGeocode = (position) => {
        this.setState({geoCode: true})
        this.APIManager.findAddressByGeocode(this.state.lat, this.state.lng, data => {
            this.setState({foundAddresses: data.Items, addressList: true}, ()=>{
                this.setState({loadingAddress: false, valid:true})
            })
        })
    }

    //finds address by id
    addressLookup = query => {
        if(this.state.geoCode === true) {
            const id = this.state.foundAddresses[query].Id;

            this.APIManager.retrieveGeocodeAddress(id, data => {
                this.setState({
                    address: data.Items[0],
                    addressList: false,
                    renderAddress:true,
                    valid:true,
                    validateErrors:{}
                }, this.updateAddressForm);
            })
        } else {
            this.APIManager.findAddress(query, data => {
                this.setState({
                    address: data.Items[0],
                    addressList: false,
                    renderAddress:true,
                    valid:true,
                    validateErrors:{}
                }, this.updateAddressForm);
            });
        }

    }

    onPostCodeChange = value => this.setState({lookUpQuery: value}, () => this.addressLookupPostcode(this.state.lookUpQuery))

    onLocationClick = () => {
        let onLocationChange = (value) => {
            this.setState({lat: value.coords.latitude, lng: value.coords.longitude}, this.addressLookupGeocode)
        }

        this.setState({loadingAddress: true}, () => {
            navigator.geolocation.getCurrentPosition(onLocationChange)
        });
    }

    updateAddressField = (value, field) => {
        let currentAddress = this.state.address;
        currentAddress[field] = value;

        this.setState({
            address: currentAddress,
        }, this.updateAddressForm)
    }

    updateAddressForm = () => {
        Object.keys(this.state.address).map( key => {
            let value = this.state.address[key];
            let element = document.querySelector('#' + this.props.formPrefixID + '_' + key)
            element.value = value;
        });
    }

    geenerateLabel = () => {
        let label = this.props.label ? this.props.label : 'Address Finder'
        if(this.props.required) label = label + ' *'
        return label;
    }

    renderLookup = () => <>
        <div className="row">
            <div className="columns medium-10 address-lookup--input">
                <label>{ this.geenerateLabel() }</label>
                <div className="form-group address-lookup--input-group">
                    <div className="address-lookup--search">
                        <input
                            className={`houseNum-input ${this.state.validateErrors.Address ? 'is-invalid-input':''}`}
                            onChange={(e) => {this.onPostCodeChange(e.target.value)}}
                            type="text"
                            placeholder="Start typing address / postcode..."
                            value={this.state.lookUpQuery}
                        />

                        {/* {navigator.geolocation &&
                            <div className={`address-lookup--search--locate-icon ${!this.state.loadingAddress ? "": "loading"}`} onClick={ () => this.onLocationClick() } >
                                <i className="icn icn-locate"></i>
                            </div>
                        }*/}

                        <div className="input-button expanded" onClick={ () => this.addressLookupPostcode(this.state.lookUpQuery) }>Find</div>
                    </div>
                    { this.state.validateErrors.Address && <small className="form-error is-visible"> { this.state.validateErrors.Address }</small> }

                    <div className={`address-lookup--dropdown ${this.state.addressList ? '':'d-none'} `} ref={this.lookUpListRef}>
                        {Object.keys(this.state.foundAddresses).map((key) => {
                            let item = this.state.foundAddresses[key];
                            return <div onClick={() => this.addressLookup(key)} className="address-lookup--dropdown--item" key={key}>
                                {item.Text}, {item.Description} <span className="">Select this address</span>
                            </div>
                        })}
                    </div>
                </div>
            </div>
        </div>

        <div className={this.state.renderAddress ? 'address-lookup--address' : 'address-lookup--address-hidden'}>
            <label>Your address</label>
            <div className="address-lookup--address--selection">
                { this.state.address && this.state.address.Label||''}
            </div>
        </div>
    </>

    render() {
        return <>
            { this.renderLookup() }
        </>;
    }
}